import { useBaseApiQuery } from "@query/baseQuery";

export const useClubQuery = () => {
    return useBaseApiQuery({ endpoint: "/organization/me/club" }, { queryKey: ["club"] });
};

export const useShopItemQuery = (club_uuid) => {
    return useBaseApiQuery({ endpoint: `/club/${club_uuid}/shopItem/page/0` }, { queryKey: ["shopItem"] });
};

export const useClubEventAllQuery = (clubUuid) => {
    return useBaseApiQuery(
        {
            'endpoint': `club/${clubUuid}/event/all` 
        },
        { 
            enabled: !!clubUuid,
            queryKey: ["clubEventAllQuery"]
        })

}


export const useClubEventQuery = (clubUuid, eventUuid) => {
    return useBaseApiQuery(
        {
            endpoint: `club/${clubUuid}/event/${eventUuid}`
        },
        {
            enabled: !!clubUuid && !!eventUuid,
            queryKey: ["clubEventQuery", clubUuid, eventUuid]
        }
    );
};